export default "__VITE_ASSET__BLrt5$vv__"